import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import TestimonialCarousel from './TestimonialCarousel';
import QuotesSlider from './QuotesSlider';
import './welcome.css';
import in_home from '../../images/in-home.png';
import features from '../../images/features.png';
import landing from '../../images/landing.jpg';
import ethics from '../../images/ethics.png';
import believe from '../../images/believe.png';
import question from '../../images/question.png';
import testimonial from '../../images/testimonial.png';
import why_mantraflex_image from '../../images/why-mantraflex-image.jpg'
import illustrator_principle from '../../images/illustrator-principle.png';
import intro_image from '../../images/intro-image.jpg';
import Layout from '../../components/Layout';

const Welcome = () => {
    const navigate = useNavigate();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <Layout>
        <div className="container">
            <section className="hero">
                <div className="hero-background">
                    <img src={landing} alt="Physiotherapy" />
                </div>
                <div className="hero-content">
                    <h1 className="hero-title">Welcome to</h1>
                    <h1 className='effect'>MantraFlex!</h1>
                    <h2 className="hero-subtitle">In-Home Physiotherapy in Ottawa</h2>
                    <p className="hero-description">
                        At MantraFlex, we specialize in guiding you toward a pain-free, active life through expert 
                        physiotherapy care. Founded by Priya Chikani, a licensed physiotherapist passionate about 
                        empowering movement, we offer evidence-based treatments for injuries, chronic pain, post-surgery 
                        recovery, and improved mobility.
                    </p>
                    <div className="button-group">
                        <button className="button primary" onClick={() => navigate('/contact')}>Contact Us</button>
                        <button className="button secondary" onClick={() => window.location.href = 'https://mantraflexinc.janeapp.com/'}>Book Appointment</button>
                    </div>
                </div>
            </section>

            <section className="intro">

                <div className='intro-image'>
                    <img src={intro_image} alt='illustrator1'/>
                </div>
                <div className="intro-item">
                    <div className="intro-heading">
                        <img src={in_home} alt="In-Home Physiotherapy" className="icon" />
                        <h2>In-Home Physiotherapy</h2>
                    </div>
                    <p>
                        <strong>In-Home Physiotherapy</strong> is a healthcare service where a licensed physiotherapist provides treatment
                        and rehabilitation directly at a patient's home. This approach is tailored for individuals who
                        may find it challenging to visit a clinic or prefer the convenience of receiving care in their own 
                        environment.
                    </p>

                    <div className="intro-heading">
                        <img src={features} alt="Key Features" className="icon" />
                        <h2>Key Features of MantraFlex</h2>
                    </div>
                    <ul className="feature-list">
                        <li>
                            <strong>Personalized Care:</strong> Treatments are customized to fit the patient's specific needs 
                            and home environment.
                        </li>
                        <li>
                            <strong>Convenience:</strong> Eliminates the need for travel, which is especially beneficial for 
                            individuals with mobility issues.
                        </li>
                        <li>
                            <strong>Comfort:</strong> Being treated at home can help patients feel more relaxed and open 
                            to therapy.
                        </li>
                        <li>
                            <strong>Comprehensive Assessment:</strong> Physiotherapists can evaluate how the home environment 
                            impacts the patient's condition and provide advice for modifications if necessary.
                        </li>
                    </ul>
                </div>

            </section>
                
            <section className="ethics">
                <div className="ethics-heading">
                    {/* <img src={ethics} alt="Ethics" className="icon" /> */}
                    <h2>Our Work Ethics</h2>
                </div>
                <p>
                    We believe in the power of collaboration and education. By working closely with you, we help you 
                    understand your body's unique needs and teach you the tools to take an active role in your recovery. 
                    Whether you're looking to recover from an injury, improve your mobility, or optimize your physical 
                    performance, we are here to support and guide you every step of the way.
                </p>
            </section>

            <section className="why-mantraflex">
                <div className="why-mantraflex-content">
                    <div className="why-mantraflex-heading">
                        {/* <img src={question} alt="question" className="icon" /> */}
                        <h2>Why Choose MantraFlex?</h2>
                    </div>
                    <p>
                        At MantraFlex, we are committed to providing you with the highest level of care and personalized 
                        treatment. Our clinic is built on trust, compassion, and a deep understanding of the human body. 
                        With a focus on the whole person, not just the injury, we create treatment plans that address your 
                        individual needs and goals.
                    </p>
                    <div className="why-mantraflex-heading">
                        {/* <img src={believe} alt="believe" className="icon" /> */}
                        <h2>What We Believe</h2>
                    </div>
                    <p>
                        We believe in a holistic approach to physiotherapy, one that focuses not only on physical recovery 
                        but also on long-term well-being. Our services are designed around three core principles that form 
                        the foundation of our practice: <strong>Align</strong>, <strong>Strengthen</strong>, <strong>Thrive</strong>.
                    </p>
                </div>
                <div className='why-mantraflex-image'>
                    <img src={why_mantraflex_image}/>
                </div>
            </section>

            <section className='principle-div'>
                <div className="principle-image">
                    <img src={illustrator_principle} alt="" />
                </div>
                <div className="principles">
                    <div className="principle">
                        <h3><strong>Align: The Foundation of Health</strong></h3>
                        <p>
                            At MantraFlex, we focus on alignment to restore movement, prevent injury, and enhance mobility. 
                            Our expert physiotherapists provide personalized treatments like manual therapy, corrective exercises, 
                            and posture training to alleviate pain and unlock your body's potential.
                        </p>
                    </div>
                    <div className="principle">
                        <h3><strong>Strengthen: Building Resilience</strong></h3>
                        <p>
                            We provide personalized treatment plans focused on building functional strength, preventing injuries, 
                            and supporting long-term health through exercises, movement training, and neuromuscular re-education. 
                            Our goal is to enhance performance and empower confident, resilient movement.
                        </p>
                    </div>
                    <div className="principle">
                        <h3><strong>Thrive: Unlock Your Full Potential</strong></h3>
                        <p>
                            We believe health is about thriving beyond pain, achieving balance for a vibrant, active life. Together, 
                            we set meaningful goals and provide tools for long-term wellness. Our mission is to empower you to 
                            flourish and live fully.
                        </p>
                    </div>
                </div>
            </section>

            <section className="testimonials">
                <div className="testimonial-heading">
                    {/* <img src={testimonial} alt="Testimonial" className="icon" /> */}
                    <h2>Our Testimonials</h2>
                </div>
                <TestimonialCarousel />
            </section>
            <QuotesSlider />
        </div>
        </Layout>
       
    );
};

export default Welcome;

